export default {
    buttons: {
        back: "后退",
        next: "下一个",
        submit: "提交"
    }
}